import { css } from "@tento-ui/component-styles";

export namespace LonaModalHeader {
  export const $style = css`
    .lona-modal-header {
      color: var(--text-pri);
      padding: 20px 20px;
      align-items: start;
    }

    .lona-modal-header h1 {
      --font-size: var(--h6-size);
      --margin-bottom: 8px;
    }

    .lona-modal-header p {
      --font-size: var(--small-size);
      color: var(--text-sec);
    }
  `;
}
